export default "__VITE_ASSET__Cvtug6Qx__"